import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import slugify from 'slugify';
import { useHistory } from 'react-router-dom';
import { useBlogs } from '../../Hooks/useBlogs';
import { blogsCollectionRef } from '../../firebase/fire-app';
import "./BlogStyles.scss";

const AddNewBlog = () => {
    const { blogs, loading } = useBlogs();
    const [similarBlog, setSimilarBlog] = useState(null);

    const { register, handleSubmit, watch, errors } = useForm();
    const blogObject = {
        title: "",
        slug: "",
        featuredImage: ``,
        content: ``,
        status: `Draft`,
        tags: [],
        category: ``,
        createdAt: new Date(),
        lastUpdated: ``,
        totalViews: 0
    }
    const [blogSlug, setBlogSlug] = useState(null);
    const [blogTitle, setBlogTitle] = useState(null)
    const history = useHistory();
    const onTitleChange = (e) => {
        setBlogTitle(e.target.value)
        const slu = slugify(e.target.value, {
            replacement: '-',
            remove: undefined,
            lower: true,
            strict: true,
            locale: 'vi'       // language code of the locale to use
        })
        if (blogs) {
            console.log("blogs are available");
            let sameBlog = null;
            sameBlog = blogs.find(item => item.slug === slu);
            setSimilarBlog(sameBlog)
            setBlogSlug(slu)
        }else{
            console.log(slu);
            setSimilarBlog(false)
            setBlogSlug(slu)
        }

    }
    const onSubmit = (data, e) => {
        data.slug = blogSlug;
        data.title = blogTitle;
        console.log(data);

        const updatedBlog = { ...blogObject, ...data }
        blogsCollectionRef.add(updatedBlog).then((docRef)=>{
            history.push("/blog/edit/" + docRef.id)
        })
        // blogsCollectionRef.doc(data.slug).set(updatedBlog)
    }
    return (
        <>
            <h3 className="text-center mt-4">Add New Blog</h3>
            <h5 className="text-center">{similarBlog ? <span className="text-danger">Similar blog url exists</span> : <span className="text-primary">Great! It's a unique blog!</span>}</h5>
            {/* <button onClick={() => console.table(blogs)} className={`btn btn-primary ${similarBlog && "disabled"}`} >Log</button> */}
            {/* <div className="container">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="row">
                                <InputWrapper col="6" label="Title">
                                    <input onChange={onTitleChange}  type="text" name="title" className="form-control"  ref={register()} />
                                </InputWrapper>
                                <InputWrapper col="6" label="URL Slug">
                                    <input type="text" name="slug" defaultValue={blogSlug} className="form-control" ref={register()} />
                                </InputWrapper>
                                <div className="col-12 text-center">
                                    {similarBlog ? <button disabled className="btn btn-secondary" type="submit" >Sorry!</button> : <button className="btn btn-primary" type="submit" >Next!</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div> */}
            <div className="container">
                <form onSubmit={handleSubmit(onSubmit)} >
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="row">
                                <InputWrapper col="6" label="Title">
                                    <input onChange={onTitleChange} type="text" name="title" className="form-control"  />
                                </InputWrapper>
                                <InputWrapper col="6" label="URL Slug">
                                    <input type="text" name="slug" defaultValue={blogSlug} className="form-control" {...register('slug')} />
                                </InputWrapper>
                                <div className="col-12 text-center">
                                    {similarBlog ? <button disabled className="btn btn-secondary" type="submit" >Sorry!</button> : <button className="btn btn-primary" type="submit" >Next!</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddNewBlog;
const InputWrapper = ({ col, label, addClass, children }) => {
    return (
        <div
            className={
                "input-group mb-3 col-md-" + col + " " + addClass
            }
        >
            <div className="input-group-prepend">
                <span className="input-group-text">{label} </span>
            </div>
            {children}
        </div>
    );
};

